export type ToolbarFeature = 'zoom' | 'rotate' | 'annotate' | 'select' | 'caret'

export const PDF_TOOLBAR_FEATURES =
  ['zoom', 'rotate', 'annotate', 'select'] as const satisfies readonly ToolbarFeature[]

export const ORGANIZER_ANNOTATE_TOOLBAR_FEATURES =
  ['annotate', 'caret'] as const satisfies readonly ToolbarFeature[]
